import React from 'react'
import { withRouter } from 'react-router-dom'

import Card from '../../../components/card'
import { AuthContext } from '../../../main/authProvider'
import GeneralServices from '../../../app/service/generalServices'
import { Button } from 'primereact/button'

import * as popUp from '../../../components/toastr'
import ConstantsUtil from '../../../context/constantsUtil'
import DateIntervalCalendar from '../../../components/calendar/dateIntervalCalendar'
import HandleErrorService from '../../../app/service/handleErrorService'
// import InputChooseTipoDePagamento from '../../../components/contasAPagar/inputChooseTipoDePagamento'
import FichaDePagamentoService from '../../../app/service/contasAPagar/fichaComparativaService'
import AuthService from '../../../app/service/authService'
import FichaComparativaTable from '../../../components/contasAPagar/fichaDePagamento/fichaComparativaTable'


class FichaComparativa extends React.Component {

    constructor(){
        super()
        this.fichaDePagamentoService = new FichaDePagamentoService()
    }


    state = {

        selectedDateFilterType: '',
        missingFilterType: false,
        missingAnyDate: false,

        initialDate: '',
        initialDateView: '',
        
        finalDate: '',
        finalDateView: '',

        // selectedTipoDePagamento: '',
        // selectedTipoDePagamentoLabel: '',
        // inputTipoDePagamentoErrorClass: '',

        loadingTable: false,
        isSearching: false,
        isFinishedSearch: false,

        habilitaBusca: true,

        fichaDePagamento: {},

        tipo: null,

    }

    componentDidMount(){

        let tipo

        // console.log("window.location.pathname: ", window.location.pathname)

        switch(window.location.pathname){
            case ConstantsUtil.fichaDeRecebimentoBoletosPathname:
                tipo = ConstantsUtil.tipoFichaComparativaRecebimentoBoleto
                break
                
            case ConstantsUtil.fichaDePagamentoPathname:
                tipo = ConstantsUtil.tipoFichaComparativaPagamentoProvisao
                break
        }

        // console.log("tipo: ", tipo)
        this.setState({tipo})

    }
    handleFilterDateChange = (selectedDateFilterType) => {
        this.setState({selectedDateFilterType})
    }

    // handleSelectionTipoDePagamentoChange = async (tipoDePagamento, label) => {
    //     await this.setState({selectedTipoDePagamento: tipoDePagamento})
    //     await this.setState({selectedTipoDePagamentoLabel: label})
    // }

    handleDateChange = async (initialDate, finalDate) => {

        await this.setState({initialDate})
        await this.setState({initialDateView: GeneralServices.convertBrStringToJsDate(initialDate)})

        await this.setState({finalDate})
        await this.setState({finalDateView: GeneralServices.convertBrStringToJsDate(finalDate)})

    }

    voltar = () => {
        this.setState({searchProvisaoResult: ''})
        this.toggleButton()
    }

    toggleButton = () => {
        this.setState({habilitaBusca: !this.state.habilitaBusca})
    }

    resetView = () => {

        this.setState({inputFilterTypeErrorClass: ''})

        this.setState({missingFilterType: false})
        this.setState({missingAnyDate: false})

        // this.setState({inputTipoDePagamentoErrorClass: ''})
        
    }

    checkData = () => {
        var check = true

        if(!this.state.selectedDateFilterType){
            this.setState({missingFilterType: true})
            check=false
        }
        
        if(!this.state.initialDate || !this.state.finalDate){
            this.setState({missingAnyDate: true})
            check=false
        }

        if(this.state.initialDate && this.state.finalDate){
            if(this.state.initialDateView > this.state.finalDateView){
                check = false
                popUp.infoPopUp(ConstantsUtil.dataInicialAnteriorFinalMessage)
           }
        }

        // if(!this.state.selectedTipoDePagamento){
        //     this.setState({inputTipoDePagamentoErrorClass: ConstantsUtil.bootstrapInputErrorClass})
        //     check=false
        // }

        return check;
    }    

    callSearch = () => {
        this.resetView()
        if(this.checkData()){
            this.search()
        }
    }

    search = () => {
        this.setState({loadingTable: true})
        this.setState({isFinishedSearch: false})
        this.setState({isSearching: true})

        // this.fichaDePagamentoService.generate(this.state.initialDate, this.state.finalDate, ConstantsUtil.tipoFichaComparativaPagamentoProvisao)
        this.fichaDePagamentoService.generate(this.state.initialDate, this.state.finalDate, this.state.tipo)
        .then(response => {
            // console.log("response: ", response.data.fichaDePagamentoList)
            this.trataResponse(response.data.fichaComparativaPrevisaoBancoList)
            this.setState({fichaDePagamento: response.data})
            this.setState({habilitaBusca: false})
        })
        .catch(error => {
            console.log("error: ", error)
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loadingTable: false})
            this.setState({isFinishedSearch: true})
            this.setState({isSearching: false})
            AuthService.stopBlockUi()
        })
    }

    trataResponse = (fichaDePagamentoResponse) => {
        fichaDePagamentoResponse.forEach(fichaDePagamentoItem => {
            
            /*
            Transforma os valores 0 em '' para que o filtro da coluna funcione corretamente.
            */

            if(fichaDePagamentoItem.valorPrevisto == 0){
                fichaDePagamentoItem.valorPrevisto = ''
            }

            if(fichaDePagamentoItem.valorSaidaBancaria == 0){
                fichaDePagamentoItem.valorSaidaBancaria = ''
            }
            
            if(fichaDePagamentoItem.saldo == 0){
                fichaDePagamentoItem.saldo = ''
            }

        })
    }

    isPagamento = () => {
        return this.state.tipo === ConstantsUtil.tipoFichaComparativaPagamentoProvisao
    }




    render() {

        const renderButtons = () => {

            if(this.state.isSearching){
                return (
                    <Button 
                        label="Buscando ..."
                        icon="pi pi-search"
                        disabled
                    />
                )
            }

            if(this.state.habilitaBusca){
                return (
                    <Button 
                        label="Buscar"
                        icon="pi pi-search"
                        onClick = {this.callSearch}
                        // style={ {maxHeight: '35px' } }
                    />
                )
            }
            return (
                <>
                    <Button 
                        label="Voltar"
                        icon="pi pi-undo"
                        className="p-button-danger"
                        onClick = {this.voltar}
                        // style={ {maxHeight: '35px' } }
                        // disabled = {this.state.isSearchingLancamentos}
                    />
                </>
            )
        }

        const renderTable = () => {
            if(!this.state.habilitaBusca){
                return (
                    <FichaComparativaTable
                        fichaComparativa={this.state.fichaDePagamento}
                        tipo={this.state.tipo}
                        search={this.search}
                        loading={this.state.loadingTable}
    
                    />
                )
            }
        }


        return (
            <div className="bs-docs-section" >

                <Card title = { this.isPagamento() ? "Ficha de Pagamento" : "Ficha de Recebimento de Boletos"}>
                    <div className='col-md-12'>
                    <div className='row'>
                        <DateIntervalCalendar
                            htmlFor="SelectDatePeriod"
                            label="Escolher período"
                            handleFilterChange={this.handleFilterDateChange}
                            handleDateChange={this.handleDateChange}
                            missingFilterType={this.state.missingFilterType}
                            missingAnyDate={this.state.missingAnyDate}
                            disabled={!this.state.habilitaBusca}
                        />
                    </div>

                    <br />
                    
                    {renderButtons()}

                    <br />
                    <br />

                    {renderTable()}

                    </div>
                </Card>


            </div>
        )
    }


}


FichaComparativa.contextType = AuthContext

export default withRouter(FichaComparativa)